import React from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';
import { isEmpty } from '../../../utils/obj-utils';

function ChangeHistorySection({
    historyContents,
    onPrintDocumentInvoiceButtonClick,
    orderTypeValues,
    noHistoryDataFoundText,
}) {
    function handleOnPrintDocumentInvoiceButtonClick(event, orderId) {
        event.preventDefault();
        onPrintDocumentInvoiceButtonClick(orderId);
    }

    function displayHistorySection() {
        const isHistoryContentsEmpty = isEmpty(historyContents);

        return (<div className='change-history'>
            <h2>{formMessageConstants.changeHistory}</h2>

            {isHistoryContentsEmpty ?
                <div className='no-files'>
                    <p className='info'>{noHistoryDataFoundText}</p>
                </div> :
                <div className='table'>
                    <div className='flex-grid table-header'>
                        <div className='col'>{formMessageConstants.order}</div>
                        <div className='col'>{formMessageConstants.type}</div>
                        <div className='col'>{formMessageConstants.open}</div>
                        <div className='col'>{formMessageConstants.confirmed}</div>
                    </div>
                    {displayHistorySummary()}
                </div>}
        </div>);
    }

    function displayHistorySummary() {
        const historyContentsLength = historyContents.length;
        return historyContents.map((historyContent, index) => {
            const isLast = historyContentsLength === index + 1;
            return (<div className={`flex-grid ${isLast ? 'last' : formMessageConstants.emptyString}`} key={index}>
                <div className='col'><span className='header'>{formMessageConstants.order}</span><span>{historyContent.orderId}</span></div>
                <div className='col'><span className='header'>{formMessageConstants.type}</span><span>{orderTypeValues[historyContent.orderTypeIndex]}</span></div>
                <div className='col'><span className='header'>{formMessageConstants.open}</span><span>{historyContent.formattedOpen}</span></div>
                <div className='col'><span className='header'>{formMessageConstants.confirmed}</span><span>{historyContent.formattedConfirmed}</span></div>
            </div>);
        });
    }
    return displayHistorySection();
}

ChangeHistorySection.propTypes = {
    historyContents: PropTypes.array.isRequired,
    orderTypeValues: PropTypes.object.isRequired,
    onPrintDocumentInvoiceButtonClick: PropTypes.func.isRequired,
    noHistoryDataFoundText: PropTypes.string
};

export default ChangeHistorySection;
